import * as React from "react";
import { Link } from "@fluentui/react";
import { parseId } from "../../helpers/idHelper";
import { useAppAuthContext } from "../../hooks/useAppAuthContext";
import { azurePortalUrl } from "../../utils";

export interface AzureSubscriptionLinkProps {
  resourceId: string;
  subscriptionName: string | undefined;
  subscriptionId?: string | undefined;
}

export const AzureSubscriptionLink = (
  { resourceId, subscriptionId, subscriptionName }: AzureSubscriptionLinkProps,
): JSX.Element => {
  const { domainName } = useAppAuthContext();
  const idComps = parseId(resourceId) || "";
  const subId = subscriptionId || decodeURIComponent(idComps?.subscriptionId || "");

  return (
    <Link
      href={`${azurePortalUrl}/#@${domainName}/resource/subscriptions/${subId}/overview`}
      target="_blank"
    >
      {subscriptionName || ""}
    </Link>
  );
};
